// import map from "../../assets/images/spiel_map.jpg";

export default function Home() {
  return (
    <div>
      {/* <div className="flex justify-center">
        <img className="sm:w-full md:w-1/4" src={map} alt="notice_image"></img>
      </div> */}
    </div>
  );
}
